import React from "react";
import ReactDOM from "react-dom";
import { Provider } from "react-redux";
import { BrowserRouter, Route } from "react-router-dom";
import {
  QueryParamProvider,
  transformSearchStringJsonSafe,
} from "use-query-params";

import { store } from "state";
import { IToolFacet } from "types";

import { ToolSearchContainer } from "./containers";

(() => {
  const searchContainer = document.querySelector<HTMLElement>(
    "[data-tool-search]"
  );

  if (!searchContainer) return;

  const data = searchContainer.dataset.toolSearch;
  searchContainer.dataset.toolSearch = ""; //cleanup

  if (!data) return;

  const toolSearchData = JSON.parse(data) as {
    facets: IToolFacet[];
    noResultMessage: string;
  };

  ReactDOM.render(
    <Provider store={store}>
      <BrowserRouter>
        <QueryParamProvider
          ReactRouterRoute={Route}
          stringifyOptions={{
            transformSearchString: transformSearchStringJsonSafe, // allow comma in query string
          }}
        >
          <ToolSearchContainer
            facets={toolSearchData.facets}
            noResultMessage={toolSearchData.noResultMessage!}
          />
        </QueryParamProvider>
      </BrowserRouter>
    </Provider>,
    searchContainer
  );
})();
